import { CloseCircleOutlined, SearchOutlined, PlusCircleOutlined, LockOutlined, UserOutlined, CreditCardOutlined, MailOutlined, PhoneOutlined, EditOutlined, DeleteOutlined, LinkOutlined, BankOutlined } from '@ant-design/icons';

import { DatePicker, Form, InputRef, Tooltip } from 'antd';
import { Button, Input, Space, Table, Modal, InputNumber, Select, Drawer } from 'antd';
import type { ColumnsType, ColumnType } from 'antd/es/table';
import type { FilterConfirmProps } from 'antd/es/table/interface';
import React, { useRef, useState, useEffect } from 'react';
import style from './Tables.module.scss'
//import { getAllUsersTable,getUserByIdentification,postResgisterUser,putUpdateUser,deleteUser,putUpdateUserPassword } from "../../../store/user/thunks";
import { getAllUsersTable, postResgisterUser, getUserById, putUpdateUser, getAllActiveGroup, getValidateUser, deleteInactiveUser, putActiveUser, putResetPassword, deleteUserById, getOrganizationsUser, postOrganizationsUser, deleteOrganizationsUser, getAllUsersPortfolioTable } from "../../../store/user/thunks";
import { deleteParentUserGroup, getAllOrganization, postRegisterParentUserGroup } from '../../../store/organization/thunks';
import { connect } from 'react-redux';
import { AppState } from '../../../store';
import { RegisterUser, Rol } from '../../../store/user/types';
import moment from 'moment';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { validateIdentification, validateLetters, validatePhoneEC, validateBirthday, validatenames, validate150, validate100 } from '../../../globals/Inputs/validateInput';
import validateMessages from '../../../globals/Inputs/validateMessages';
import { typesIdentification } from '../../../globals/Parameters/listParameters';
import TextArea from 'antd/es/input/TextArea';
import locale from 'antd/lib/date-picker/locale/es_ES';
import { Organization } from '../../../store/organization/types';
import { openNotification } from '../../../globals/Components/Notification/Notificaction';
import 'moment/locale/es'; // Importar el locale español
import LoadingIndicator from 'src/globals/Components/Loading/LoadingIndicator';
import { Organizations } from './TOrganizations';
import dayjs from 'dayjs';
import AdminHeader from 'src/globals/Layout/Admin/AdminHeader';

moment.locale('es');



interface UserTableProps {
    postOrganizationsUser?: any;
    deleteOrganizationsUser?: any;
    getOrganizationsUser?: any;
    putResetPassword?: any;
    putActiveUser?: any;
    deleteInactiveUser?: any;
    getValidateUser?: any;
    getUserById?: any;
    getAllOrganization?: any;
    getAllUsersTable?: any;
    getUserByIdentification?: any;
    postResgisterUser?: any;
    putUpdateUser?: any;
    deleteUser?: any;
    putUpdateUserPassword?: any;
    getAllActiveGroup?: any;
    deleteUserById?: any;
    validatePortfolio: boolean;
    postRegisterParentUserGroup?: any;
    organizationParentId?: any;
    getAllUsersPortfolioTable?: any;
    usersPortfolioTable?: [] | any;
    deleteParentUserGroup?: any;
}

interface DataType {
    key: string;
    id: string;
    organization: string;
    fullname: string;
    firstname: string;
    lastname: string;
    identification: string;
    type: string;
    email: string;
    rol: string;
    rol_name: string;
    position: string;
    area: string;
    phone: string;
    birthday: string;
    status: string;
    createdAt: string;
    terms: string;
    msOrganizationOrganizationRuc: string;
    msOrganizationOrganizationId: string;
    organization_parent_id: string;


}

type DataIndex = keyof DataType;
type RequiredMark = boolean | 'optional';
const TUser: React.FC<UserTableProps> = (props: UserTableProps) => {
    const dateFormat = 'YYYY-MM-DD';
    const [form] = Form.useForm();
    const [formOrganization] = Form.useForm();
    const [formValidate] = Form.useForm();
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef<InputRef>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpenForm, setIsModalOpenForm] = useState(false);
    const [isDrawerOrganization, setIsDrawerOrganization] = useState(false);
    const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
    const [isModalValidateUser, setIsModalValidateUse] = useState(false);
    const [isModalValidateInactiveUser, setIsModalValidateInactiveUser] = useState(false);
    const [typeModal, setTypeModal] = useState(true);
    const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');
    const { Option } = Select;
    const [type, setType] = useState("");
    const [types, setTypes] = useState(Array<string>);
    const [userData, setUserData] = useState<DataType>();
    const [isFormValidate, setIsFormValidate] = useState(true);
    const [requiredMark, setRequiredMarkType] = useState<RequiredMark>('optional');
    const [isOrganizations, setOrganizations] = useState([]);
    const actualDate = new Date();

    const [rolApi, setRolApi] = useState<Rol[]>([]);
    const [organization, setOrganization] = useState([]);

    const [dataTable, setDataTable] = useState(props.usersPortfolioTable || []);

    useEffect(() => {        
      if (props.usersPortfolioTable) {
        setDataTable(props.usersPortfolioTable);
      }
    }, [props.usersPortfolioTable]);

    const init = async () => {
        
        if (!props.validatePortfolio) {
            //Portafolio           
            const responseData = await props.getAllUsersTable();          
            setDataTable(responseData);

        }
    }
    useEffect(() => {
        init();
    }, []);

    const copyLink = (id: string) => {
        const textarea = document.createElement('textarea');
        textarea.value = process.env.REACT_APP_BASE_URL as string + "/reset-password/" + id;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        openNotification("Notificación", "Enlace copiado");
    }


    const handleSearch = (
        selectedKeys: string[],
        confirm: (param?: FilterConfirmProps) => void,
        dataIndex: DataIndex,
    ) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };

    const handleReset = (clearFilters: () => void) => {
        clearFilters();
        setSearchText('');
    };

    const getColumnSearchProps = (dataIndex: DataIndex, title: string): ColumnType<DataType> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Buscar ${title}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reiniciar
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes((value as string).toLowerCase()),
        onFilterDropdownOpenChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },

    });

    const columns: ColumnsType<DataType> = [
        {
            title: 'Nombres',
            width: 250,
            dataIndex: 'fullname',
            key: 'fullname',
            //fixed: 'left',
            ...getColumnSearchProps('fullname', 'nombres'),
        },
        {
            title: 'Identificación',
            width: 180,
            dataIndex: 'identification',
            key: 'identification',
            //fixed: 'left',
            ...getColumnSearchProps('identification', 'identificación'),
        },

        {
            title: 'Tipo',
            dataIndex: 'type',
            key: 'type',
            width: 90,
        },

        {
            title: 'Correo',
            dataIndex: 'email',
            key: 'email',
            width: 250,
            ...getColumnSearchProps('email', 'correo'),
        },
        {
            title: 'Rol',
            dataIndex: 'rol_name',
            key: 'rol_name',
            width: 125,
            ...getColumnSearchProps('rol', 'rol'),
        },
        {
            title: 'Puesto',
            dataIndex: 'position',
            key: 'position',
            width: 180,
            ...getColumnSearchProps('position', 'position'),
        },
        {
            title: 'Área',
            dataIndex: 'area',
            key: 'area',
            width: 150,
            ...getColumnSearchProps('area', 'area'),
        },
        {
            title: 'Teléfono',
            dataIndex: 'phone',
            key: 'phone',
            width: 150,
            ...getColumnSearchProps('phone', 'teléfono'),
        },

        {
            title: 'Estado',
            dataIndex: 'status',
            key: 'status',
            width: 100,
            filters: [
                {
                    text: 'Activo',
                    value: 'ACTIVO',
                },
                {
                    text: 'Inactivo',
                    value: 'INACTIVO',
                },
            ],
            onFilter: (value: string | number | boolean, record) => {
                if (typeof value === 'string') {
                    return record.status.indexOf(value) === 0;
                }
                return false;
            },
        },
        {
            title: 'Términos y condiciones',
            dataIndex: 'terms',
            key: 'terms',
            width: 180,
        },
        {
            title: 'Creado',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 150,
            defaultSortOrder: 'descend',
            sorter: (a, b) => {
                const dateA = new Date(a.createdAt);
                const dateB = new Date(b.createdAt);

                if (isNaN(dateA.getTime())) {
                    return -1;
                }
                if (isNaN(dateB.getTime())) {
                    return 1;
                }

                return dateA.getTime() - dateB.getTime();
            },
            ...getColumnSearchProps('createdAt', 'createdAt'),
        },
        {
            title: '',
            key: 'operation',
            fixed: 'right',
            width: 240,

            render: (record: DataType) =>
                <Space size="middle">

                    <Tooltip placement="topRight" title={validateMessages.linkButton} >
                        <Button
                            type="text"
                            className={style["link-button"]}
                            onClick={() => copyLink(record.id)}
                            icon={<LinkOutlined />}
                        />

                    </Tooltip>
                    {!props.validatePortfolio && <Tooltip placement="topRight" title={validateMessages.organizationButton} >
                        <Button
                            type="text"
                            className={style["update-button"]}
                            onClick={() => showDrawerOrganization(record)}
                            icon={<BankOutlined />}
                        />

                    </Tooltip>}
                    <Tooltip placement="topRight" title={validateMessages.updateButton} >
                        <Button
                            type="text"
                            className={style["update-button"]}
                            onClick={() => showModalUpdate(record.id)}
                            icon={<EditOutlined />}
                        />
                    </Tooltip>

                    {!props.validatePortfolio && record.status === 'ACTIVO' && (
                        <Tooltip placement="topRight" title={validateMessages.inactiveButton} >
                            <Button
                                type="text"
                                className={style["danger-button"]}
                                onClick={() => deleteUserTable(record)}
                                icon={<DeleteOutlined />}
                            />
                        </Tooltip>
                    )}
                    <Tooltip placement="topRight" title={validateMessages.deleteButton} >
                        <Button
                            type="text"
                            className={style["eliminate-button"]}
                            onClick={() => handleTypeDeleteButton(record)}
                            icon={<CloseCircleOutlined />}
                        />
                    </Tooltip>


                </Space>,
        },

    ];
    const handleOk = () => {
        form.resetFields();
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        form.resetFields();
        setIsModalOpen(false);
    };
    const handleOkForm = () => {
        form.resetFields();
        setIsModalOpenForm(false);
    };
    const handleCancelForm = () => {
        setIsDrawerOrganization(false);
        form.resetFields();
        setIsModalOpenForm(false);
    };
    const handleDeleteOk = async () => {
        setIsModalDeleteOpen(false);
        await props.deleteInactiveUser(userData?.id);
        const responseData = await props.getAllUsersTable();       
        setDataTable(responseData);
    };
    const handleValidateUserOk = async () => {
        setIsModalValidateUse(false);
    };

    const handleValidateInactiveUserOk = async () => {
        const registerUser = {
            id: userData?.id
        };
        await props.putActiveUser(registerUser);
        const responseData = await props.getAllUsersTable();       
        setDataTable(responseData);
        setIsModalValidateInactiveUser(false);
    };
    const handleDeleteCancel = () => {
        setIsModalDeleteOpen(false);
    };
    const handleValidateUserCancel = () => {
        setIsModalValidateUse(false);
    };
    const handleValidateInactiveUserCancel = () => {
        setIsModalValidateInactiveUser(false);
    };
    const onFormLayoutChange = ({ size }: { size: SizeType }) => {
        setComponentSize(size);
    };

    const showModalCreate = async () => {

        if (props.validatePortfolio) {
            setIsFormValidate(true);
            setIsModalOpen(true);
            setTypeModal(true);
        } else {
            const responseDataOrganization = await props.getAllOrganization();
            const responseDataRol = await props.getAllActiveGroup();
            setOrganization(responseDataOrganization);
            setRolApi(responseDataRol);
            setIsFormValidate(true);
            setIsModalOpen(true);
            setTypeModal(true);
        }



    };
    const showDrawerOrganization = async (value: DataType) => {
        setUserData(value);
        setIsDrawerOrganization(true)
        const responseDataOrganization = await props.getAllOrganization();
        setOrganization(responseDataOrganization);
        const responseData = await props.getOrganizationsUser(value.id);
        setDataTableOrganizations(responseData);
    }
    const showModalUpdate = async (value: String) => {

        const responseDataRol = await props.getAllActiveGroup();
        setRolApi(responseDataRol);

        const responseData: RegisterUser = await props.getUserById(value);
        const group = responseDataRol.find((group: any) => group.name === responseData.rol);
        if (responseData.birthday == null) {
            form.setFieldsValue({
                firstname: responseData.firstname, lastname: responseData.lastname, organization: responseData.organizationId,
                type: responseData.type, identification: responseData.identification, position: responseData.position, area: responseData.area,
                email: responseData.email, phone: responseData.phone, rol: group.id
            });
        } else {
            form.setFieldsValue({
                firstname: responseData.firstname, lastname: responseData.lastname, organization: responseData.organizationId,
                type: responseData.type, identification: responseData.identification, position: responseData.position, area: responseData.area,
                email: responseData.email, phone: responseData.phone, birthday: moment(responseData.birthday, 'YYYY-MM-DD'),
            });
        }
        setUserData({
            fullname: responseData.firstname, key: "1", id: responseData.id, status: "", organization: responseData.organizationId, area: responseData.area,
            type: responseData.type, identification: responseData.identification, rol: responseData.rol, rol_name: responseData.rolname, createdAt: responseData.createdAt,
            email: responseData.email, phone: responseData.phone, birthday: responseData.birthday, position: responseData.position, msOrganizationOrganizationRuc: responseData.msOrganizationOrganizationRuc,
            terms: responseData.terms, msOrganizationOrganizationId: responseData.msOrganizationOrganizationId, firstname: responseData.firstname, lastname: responseData.lastname, organization_parent_id: ""
        });
        setIsModalOpenForm(true);
        setIsFormValidate(false);
        setTypeModal(false);
    };
    const updateUserPassword = async () => {
        const updateUser = {

            id: userData?.id,
        };
        await props.putResetPassword(updateUser);
        setIsModalOpen(false);
    }
    const deleteUserTable = async (id: DataType) => {
        setUserData(id)
        setIsModalDeleteOpen(true);

    };

    const getRucByOrganizationId = (id: string, organizations: Organization[]): string | undefined => {
        const org = organizations.find(organization => organization.id === id); // Busca la organización por id
        return org ? org.ruc : undefined; // Si la organización existe, retorna el RUC, sino undefined
    };

    const onFinish = async (values: any) => {

        const registerUser = {
            type: values.type,           
            firstname: values.firstname,
            lastname: values.lastname,
            email: values.email,
            position: values.position,
            area: values.area,
            phone: values.phone,
            birthday: null,
            rol: values.rol,
        };        
        handleCancel();
        if (props.validatePortfolio) {
            if (typeModal) {
                if (isValidateUserForm) {
                    const request = {
                        OrganizationParentId: props.organizationParentId,
                        UserId: userData?.id
                    }
                    await props.postRegisterParentUserGroup(request);

                } else {

                }
            } else {
                await props.putUpdateUser(registerUser);
            }
            handleCancelForm()
            const responseData = await props.getAllUsersPortfolioTable(props.organizationParentId);          
            setDataTable(responseData);

        } else {
            if (typeModal) {
                await props.postResgisterUser(registerUser);

            } else {
                await props.putUpdateUser(registerUser);
            }
            handleCancelForm()
            const responseData = await props.getAllUsersTable();           
            setDataTable(responseData);

        }

        form.resetFields();
    };
    const [isValidateUserForm, setIsValidateUserForm] = useState(false);
    const onFinishValidate = async (values: any) => {
        const responseDataValidate = await props.getValidateUser(values.email);
        if (props.validatePortfolio) {
            const responseData: RegisterUser = await props.getUserById(responseDataValidate.id);
            const responseDataRol = await props.getAllActiveGroup();
            setRolApi(responseDataRol);
            if (responseData != null) {
                setIsValidateUserForm(true);
                const group = responseDataRol.find((group: any) => group.name === responseData.rol);
                if (responseData.birthday == null) {
                    form.setFieldsValue({
                        firstname: responseData.firstname, lastname: responseData.lastname, organization: responseData.organizationId,
                        type: responseData.type, identification: responseData.identification, position: responseData.position, area: responseData.area,
                        email: responseData.email, phone: responseData.phone, rol: group.id
                    });
                } else {
                    setIsValidateUserForm(false);
                    form.setFieldsValue({
                        firstname: responseData.firstname, lastname: responseData.lastname, organization: responseData.organizationId,
                        type: responseData.type, identification: responseData.identification, position: responseData.position, area: responseData.area,
                        email: responseData.email, phone: responseData.phone, birthday: moment(responseData.birthday, 'YYYY-MM-DD'),
                    });
                }
                setUserData({
                    fullname: responseData.firstname, key: "1", id: responseData.id, status: "", organization: responseData.organizationId, area: responseData.area,
                    type: responseData.type, identification: responseData.identification, rol: responseData.rol, rol_name: responseData.rolname, createdAt: responseData.createdAt,
                    email: responseData.email, phone: responseData.phone, birthday: responseData.birthday, position: responseData.position, msOrganizationOrganizationRuc: responseData.msOrganizationOrganizationRuc,
                    terms: responseData.terms, msOrganizationOrganizationId: responseData.msOrganizationOrganizationId, firstname: responseData.firstname, lastname: responseData.lastname, organization_parent_id: ""
                });



                setIsModalOpenForm(true);
                setIsModalOpen(false);
                setIsFormValidate(false);

            }
        } else {
            if (responseDataValidate != null && responseDataValidate.status.trim() == "ACTIVE") {
                const dataUser: DataType = {
                    key: "1",
                    id: responseDataValidate.id,
                    msOrganizationOrganizationRuc: "",
                    msOrganizationOrganizationId: "",
                    terms: "",
                    organization: "",
                    type: "",
                    rol: "",
                    organization_parent_id: "",
                    rol_name: "",
                    position: "",
                    area: "",
                    phone: "",
                    birthday: "",
                    status: "",
                    createdAt: "",
                    identification: responseDataValidate.identification,
                    fullname: responseDataValidate.firstName,
                    firstname: responseDataValidate.firsName,
                    lastname: responseDataValidate.lastName,
                    email: responseDataValidate.email,
                };

                setUserData(dataUser);
                setIsModalOpen(false);
                setIsModalValidateUse(true);


            } else if (responseDataValidate != null && responseDataValidate.status.trim() == "INACTIVE") {
                const dataUser: DataType = {
                    key: "1",
                    id: responseDataValidate.id,
                    terms: "",
                    organization: "",
                    msOrganizationOrganizationRuc: "",
                    msOrganizationOrganizationId: "",
                    type: "",
                    rol: "",
                    rol_name: "",
                    organization_parent_id: "",
                    position: "",
                    area: "",
                    phone: "",
                    birthday: "",
                    status: "",
                    createdAt: "",
                    identification: responseDataValidate.identification,
                    fullname: responseDataValidate.firstName,
                    firstname: responseDataValidate.firstName,
                    lastname: responseDataValidate.lastName,
                    email: responseDataValidate.email
                };
                setUserData(dataUser);
                setIsModalOpen(false);
                setIsModalValidateInactiveUser(true);

            } else {
                form.setFieldsValue({
                    type: values.type,
                    identification: values.identification,
                    email: values.email
                });

                setIsModalOpenForm(true);
                setIsModalOpen(false);
                setIsFormValidate(false);

            }
            formValidate.resetFields();

        }






    };

    const [isModalDeleteMethodOpen, setIsModalDeleteMethodOpen] = useState(false);
    const [isIdData, setIdData] = useState<String>("");
    const handleDeleteMethodOk = async () => {        
        if (props.validatePortfolio) {
            const responseData = await props.deleteParentUserGroup(userData?.organization_parent_id);
            if (responseData != undefined) {
                const responseData = await props.getAllUsersPortfolioTable(props.organizationParentId);               
                setDataTable(responseData);
                
            }
        } else {
            const responseData = await props.deleteUserById(isIdData);
            if (responseData != undefined) {
                const responseDataEstablishment = await props.getAllUsersTable();                
                setDataTable(responseDataEstablishment);
            }
        }


        setIsModalDeleteMethodOpen(false);
    };
    const handleDeleteMethodCancel = () => {
        setIsModalDeleteMethodOpen(false);
    };
    const handleTypeDeleteButton = async (value: DataType) => {
        setUserData(value);
        setIdData(value.id);
        setIsModalDeleteMethodOpen(true);

    }
    const [searchValue, setSearchValue] = useState<Organizations>();

    const [dataTableOrganizatons, setDataTableOrganizations] = useState([]);

    const onRegisterOrganizations = async (values: any) => {
        const organizationUser = {
            organizationId: values.organization,
            userId: userData?.id
        }
        await props.postOrganizationsUser(organizationUser);
        const responseData = await props.getOrganizationsUser(userData?.id);
        setDataTableOrganizations(responseData);

    }
    const onDeleteOrgnizationUser = async (values: Organization) => {
        await props.deleteOrganizationsUser(values.id,userData?.id);
        const responseData = await props.getOrganizationsUser(userData?.id);
        setDataTableOrganizations(responseData);

    }

    const columnsOrganization: ColumnsType<Organization> = [
        {
            title: '',
            width: 10,
            dataIndex: 'key',
            key: 'key',


        },
        {
            title: '',
            width: 0,
            dataIndex: 'id',
            key: 'id',
            render: () => null,
        },
        {
            title: '',
            width: 0,
            dataIndex: 'msCatalogueCountryId',
            key: 'msCatalogueCountryId',
            render: () => null,
        },
        {
            //cOMO YO QUIERO QUE APAREZCA
            title: 'Nombre',
            width: 60,
            //TA LCUAL COMO SE DECLARA EN EL DATATYPE
            dataIndex: 'name',
            //SE ENVIA EL MISMO QUE EL DATATYPE
            key: 'name',
            //MANTENER FORMATO
            //fixed: 'left',
            //BUSCADOR MODIFICADO PARA ESPANOL

        },
        {
            title: 'RUC',
            width: 50,
            dataIndex: 'ruc',
            key: 'ruc',
            //fixed: 'left',
        },


        {
            title: '',
            key: 'operation',
            fixed: 'right',
            width: 60,

            render: (record: Organization) =>
                <Space size="middle">


                    <Tooltip placement="topRight" title={validateMessages.deleteButton} >
                        <Button
                            type="text"
                            className={style["eliminate-button"]}
                            onClick={() => onDeleteOrgnizationUser(record)}
                            icon={<CloseCircleOutlined />}
                        />
                    </Tooltip>

                </Space>,
        },

    ];
    return (
        <>
            <Button
                type="primary"
                icon={<PlusCircleOutlined />}
                className={style["create-button-user"]}
                onClick={showModalCreate}
            >
                Crear usuario
            </Button>
            <Table size="small" columns={columns} dataSource={dataTable} scroll={{ x: 1500 }} />
            <Modal open={isModalOpen} onOk={handleOk} onCancel={handleCancel}
                width={350} footer={null}       >
                <AdminHeader className={style["title-modal"]}>
                    {isFormValidate ? "Validar usuario" : typeModal ? "Crear un nuevo usuario" : "Actualizar usuario"}
                </AdminHeader>
                <Form
                    form={formValidate}
                    layout="vertical"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onFinishValidate}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                >
                    
                    <Form.Item name="email" label="Correo electrónico" rules={[{ required: true, message: validateMessages.emptyField }, { type: 'email', message: validateMessages.invalidEmail }]}>
                        <Input placeholder="Ingresar correo electrónico" />
                    </Form.Item>


                    <Form.Item>
                        <Button  className={style["create-button-user"]} type="primary" htmlType="submit">
                            Validar
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
            <Drawer title={"Agregar nueva organización"} open={isDrawerOrganization} onClose={handleCancelForm} width={950} footer={null}>

                <h3>Seleccionar una organización</h3>
                <Form
                    form={formOrganization}
                    layout="inline"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onRegisterOrganizations}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                >
                    <Form.Item className={style["select-fe"]} name="organization" rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <Select

                            showSearch
                            style={{ width: "100%" }}
                            onChange={(type: Organizations) => setSearchValue(type)}
                            filterOption={(input: any, option: any) =>
                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }

                            value={searchValue}
                            placeholder="Escoga la organización"
                        >
                            {organization.map((type: Organization) => (
                                <Option key={`type-option-${type}`} value={type.id}
                                >
                                    {type.name + "-" + type.ruc}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item  >
                        <Button
                            htmlType="submit"
                            type="primary"
                            className={style["create-button-user-select"]}
                        >
                            Guardar selección
                        </Button>
                    </Form.Item>
                </Form>
                <Table size="small" columns={columnsOrganization} dataSource={dataTableOrganizatons} scroll={{ x: 500 }} />
                <LoadingIndicator />
            </Drawer>



            <Drawer title={typeModal ? "Crear una nuevo usuario" : "Actualizar usuario"} open={isModalOpenForm} onClose={handleCancelForm} width={350} footer={null}>

                <Form
                    form={form}
                    layout="vertical"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onFinish}
                    onValuesChange={onFormLayoutChange}
                    size={componentSize as SizeType}
                >
                    {typeModal ?
                        <>
                            <h4>Contraseña por defecto: Greenwise${moment(actualDate).format("YYYY")}</h4>
                        </>
                        : <Button
                            type="primary"
                            className={style["reset-button-user"]}
                            onClick={updateUserPassword}
                        >
                            Restablecer contraseña
                        </Button>}
                    <Form.Item label="Nombres" name="firstname" rules={[{ required: true, message: validateMessages.emptyField }, { validator: (_, value) => validatenames(value) },]}>
                        <Input placeholder="Ingresar nombres" />
                    </Form.Item>
                    <Form.Item label="Apellidos" name="lastname" rules={[{ required: true, message: validateMessages.emptyField }, { validator: (_, value) => validatenames(value) },]}>
                        <Input placeholder="Ingresar apellidos" />
                    </Form.Item>                   
                    <Form.Item style={props.validatePortfolio ? { display: "none" } : {}} label="Rol" name="rol" rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <Select
                            style={{ width: "100%" }}
                            onChange={(type: string) => setType(type)}
                            value={type}
                            placeholder="Escoga un rol"
                        >
                            {rolApi.map((type: Rol) => (
                                <Option key={`type-option-${type}`} value={type.id}
                                >
                                    {type.name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item name="position" label="Posición" rules={[{ required: true, message: validateMessages.emptyField }, { validator: (_, value) => validate150(value) }]}>
                        <Input placeholder="Ingresar puesto" />
                    </Form.Item>
                    <Form.Item name="area" label="Área" rules={[{ required: true, message: validateMessages.emptyField }, { validator: (_, value) => validate150(value) }]}>
                        <Input placeholder="Ingresar área" />
                    </Form.Item>
                    <Form.Item name="email" label="Correo electrónico" rules={[{ required: true, message: validateMessages.emptyField }, { type: 'email', message: validateMessages.invalidEmail }]}>
                        <Input disabled={true} placeholder="Ingresar correo electrónico" />
                    </Form.Item>
                    <Form.Item name="phone" label="Celular" rules={[{ required: true, message: validateMessages.emptyField }, { validator: (_, value) => value.type == 'Cédula de ciudadania' ? validatePhoneEC(value) : validate100(value) },]}>
                        <Input placeholder="Ingresar celular" />
                    </Form.Item>
                    <Form.Item label="Fecha de nacimiento" name="birthday" hidden={true}>
                        <DatePicker locale={locale} format={dateFormat} className={style["user-input-datepiker"]} placeholder="Ingresar fecha de nacimiento" />
                    </Form.Item>

                    <Form.Item>
                        <Button className={style["user-button"]} type="primary" htmlType="submit">
                            {typeModal ? "Agregar" : "Actualizar"}
                        </Button>
                    </Form.Item>
                </Form>
            </Drawer>
            <Modal open={isModalDeleteOpen} onOk={handleDeleteOk} onCancel={handleDeleteCancel}>
                <h3>¿Esta seguro de inactivar el usuario {userData?.fullname} con cédula {userData?.identification}? </h3>
            </Modal>
            <Modal open={isModalValidateUser} onOk={handleValidateUserOk} onCancel={handleValidateUserCancel}>
                <h3>El usuario {userData?.fullname} con cédula {userData?.identification} y {userData?.email} ya se encuentra activo </h3>
            </Modal>
            <Modal open={isModalValidateInactiveUser} onOk={handleValidateInactiveUserOk} onCancel={handleValidateInactiveUserCancel}>
                <h3>El usuario {userData?.fullname} con cédula {userData?.identification} y {userData?.email} se encuentra inactivo. <br /> ¿Deseas activarlo? </h3>
            </Modal>
            <Modal open={isModalDeleteMethodOpen} onOk={handleDeleteMethodOk} onCancel={handleDeleteMethodCancel}>
                <h3>¿Esta seguro que desea eliminar el Usuario? </h3>
            </Modal>

        </>


    );


};

const mapStateToProps = (state: AppState) => ({

});

export default connect(mapStateToProps, {
    getAllUsersTable, getAllOrganization, postResgisterUser, getUserById, putUpdateUser, getValidateUser, putActiveUser,
    deleteInactiveUser, putResetPassword, getAllActiveGroup, deleteUserById, getOrganizationsUser, postOrganizationsUser,
    deleteOrganizationsUser, postRegisterParentUserGroup, getAllUsersPortfolioTable, deleteParentUserGroup
})(TUser);